import Logo from "./logo.component";
import { siteContent } from "../../content";
const socialMedia = siteContent.socialMedia;

const LayoutHeader = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 py-10 gap-5 md:gap-10">
      <Logo />
      <div className="flex justify-end flex-row h-auto">
        {socialMedia.map((item, k) => (
          <a
            key={k}
            className="first:mr-0 ml-1 p-1  hover:shadow-lg rounded-lg text-white w-12 h-12 flex justify-center items-center transition-all duration-200 opacity-70 hover:opacity-100"
            href={item.href}
            title={item.title}
            target="_blank"
            rel="noreferrer"
          >
            <img className="w-8 h-8" src={item.img} alt="facebook" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default LayoutHeader;
